import { ApiError } from '@/lib/api'
import { QueryCache, QueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

// KVM4 (Hostinger) is mid-tier shared compute — keep server load low.
// - long staleTime: refetch only when data is genuinely stale, prefer WebSocket invalidation
// - retry once: don't hammer a struggling server
// - no auto-refetch on focus / reconnect: WS push handles freshness
// - 10-minute gcTime: keep payloads in memory instead of re-fetching after navigation
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (error instanceof ApiError) {
          if (
            error.status === 401 ||
            error.status === 403 ||
            error.status === 404
          ) {
            return false
          }
        }
        return failureCount < 1
      },
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      staleTime: 60_000,
      gcTime: 10 * 60_000
    },
    mutations: {
      retry: 0
    }
  },
  queryCache: new QueryCache({
    onError: (error) => {
      if (error instanceof ApiError && error.status === 401) {
        return
      }
    }
  })
})

export function notifyError(prefix: string, error: unknown): void {
  const message =
    error instanceof ApiError
      ? (error.detail ?? error.message)
      : error instanceof Error
        ? error.message
        : String(error)
  toast.error(prefix, { description: message })
}
